import { TDT_KEY } from '@/config'
import * as Cesium from 'cesium'
import TdtPlug from '@/lib/tdtplug.es.js'
import { isDev } from '../utils'
import bridgeUri from '@/assets/bridge.glb?url'
import * as turf from '@turf/turf'
export { BASELAYERS } from './BaseLayerSelector'
/**创建viewer */
export function createViewer(dom: HTMLDivElement) {
  const viewer = new Cesium.Viewer(dom, {
    // imageryProvider: init_layer,
    animation: false, //是否创建动画小器件，左下角仪表
    baseLayerPicker: false, //是否显示图层选择器
    fullscreenButton: false, //是否显示全屏按钮
    geocoder: false, //是否显示geocoder小器件，右上角查询按钮
    homeButton: false, //是否显示Home按钮
    infoBox: false, //是否显示信息框
    sceneModePicker: false, //是否显示3D/2D选择器
    selectionIndicator: false, //是否显示选取指示器组件
    timeline: false, //是否显示时间轴
    navigationHelpButton: false, //是否显示右上角的帮助按钮
    scene3DOnly: true,
    baseLayer: false,
    contextOptions: {
      webgl: {
        antialias: true,
      },
    },
  })
  // 去除logo
  ;(viewer.cesiumWidget.creditContainer as HTMLDivElement).style.display = 'none'
  // // 显示帧率
  // viewer.scene.debugShowFramesPerSecond = true
  // 开启深度检测，打开后地形会遮挡看不到的区域
  viewer.scene.globe.depthTestAgainstTerrain = true
  // 对大气和雾启用动态照明效果
  // viewer.scene.globe.enableLighting = true
  if (isDev) {
    viewer.scene.debugShowFramesPerSecond = true
  }
  // 自动播放动画
  viewer.clock.shouldAnimate = true
  viewer.screenSpaceEventHandler.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_DOUBLE_CLICK)
  return viewer
}
/** 叠加地形服务 */
export async function addTerrain(viewer: Cesium.Viewer) {
  const subdomains = ['0', '1', '2', '3', '4', '5', '6', '7']
  const provider = new TdtPlug.GeoTerrainProvider({
    url: 'https://t{s}.tianditu.gov.cn/mapservice/swdx?T=elv_c&x={x}&y={y}&l={z}&tk={token}',
    subdomains,
    token: TDT_KEY,
  })
  viewer.terrainProvider = provider
  // viewer.terrainProvider = await Cesium.CesiumTerrainProvider.fromUrl('http://localhost/terrain')
}

/**设置初始视角 */
export function setHomeView(viewer: Cesium.Viewer) {
  const viewCopy = {
    position: {
      x: -2820843.189014731,
      y: 5020080.386305515,
      z: 2787505.3282351703,
    },
    heading: 6.283185307179582,
    pitch: -1.5693996502204395,
    roll: 0,
  }
  const xyz = viewCopy.position
  const position = new Cesium.Cartesian3(xyz.x, xyz.y, xyz.z)
  viewer.camera.setView({
    destination: position,
    orientation: {
      heading: viewCopy.heading,
      pitch: viewCopy.pitch,
      roll: viewCopy.roll,
    },
  })
}

/** 添加大桥 */
export function addBridge(viewer: Cesium.Viewer) {
  let origin = turf.point([119.392, 25.9603])
  origin = turf.destination(origin, 590.28, 90, { units: 'meters' })
  origin = turf.destination(origin, 354.92, 0, { units: 'meters' })

  const entity = new Cesium.Entity({
    model: {
      uri: bridgeUri,
      scale: 1,
    },

    position: Cesium.Cartesian3.fromDegrees(
      origin.geometry.coordinates[0],
      origin.geometry.coordinates[1]
    ),
  })
  viewer.entities.add(entity)
  const hpr = new Cesium.HeadingPitchRoll(Cesium.Math.toRadians(270), 0, 0)
  entity.orientation = new Cesium.ConstantProperty(
    Cesium.Transforms.headingPitchRollQuaternion(entity.position!.getValue()!, hpr)
  )
}
